// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LiveChat: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M5.688 6.875a.52.52 0 00-.547.547.547.547 0 001.094 0 .533.533 0 00-.547-.547zm.454-3.938h-.996a1.21 1.21 0 00-1.208 1.21.437.437 0 10.875 0c0-.184.15-.335.333-.335h.994a.422.422 0 01.184.801l-.839.435c-.145.052-.235.225-.235.389V6a.437.437 0 10.875 0v-.298l.596-.31c.419-.218.717-.663.717-1.158 0-.714-.583-1.296-1.296-1.296zm5.233 2.626C11.375 2.905 8.83.75 5.688.75 2.546.75 0 2.905 0 5.563c0 1.134.467 2.174 1.243 2.996a7.185 7.185 0 01-1.065 1.597.647.647 0 00.47 1.094c1.48 0 2.672-.567 3.442-1.071a6.674 6.674 0 001.598.196c3.141 0 5.687-2.155 5.687-4.813zM5.688 9.5c-.464 0-.931-.057-1.388-.17l-.37-.093-.32.211c-.56.366-1.41.793-2.457.902.256-.332.61-.838.881-1.417l.253-.54-.408-.432C1.222 7.263.875 6.435.875 5.563c0-2.172 2.136-3.938 4.813-3.938 2.677 0 4.812 1.766 4.812 3.938 0 2.17-2.16 3.937-4.812 3.937zm10.893 3.155a4.51 4.51 0 00.92-2.717c0-2.658-2.352-4.813-5.25-4.813l-.026.001c.012.144.025.289.025.436 0 .149-.013.295-.026.44L12.25 6c2.412 0 4.375 1.766 4.375 3.938 0 .784-.258 1.543-.745 2.194l-.358.478.315.507c.18.29.36.54.508.731a5.262 5.262 0 01-1.484-.385l-.347-.145-.344.152a4.734 4.734 0 01-1.92.405c-2.052 0-3.765-1.283-4.235-3-.277.092-.56.168-.853.227.568 2.092 2.603 3.648 5.088 3.648.816 0 1.584-.175 2.273-.48.653.275 1.438.48 2.33.48a.648.648 0 00.468-1.093c-.004-.006-.379-.416-.74-1.002zM10.63 9.992a.437.437 0 000 .619l1.02 1.022a.437.437 0 00.618 0l2.26-2.261a.437.437 0 10-.618-.619l-1.952 1.952-.711-.712a.437.437 0 00-.617 0z" />
        </svg>
    );
};

export default React.memo(LiveChat);
